import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Row, Button, Container } from "reactstrap";
import SimilarProductsSlider from "./SimilarProducts";
import RecentViewedSlider from "./RecentView";
import { AddToCart } from "../../api/cartService";
import InnerImageZoom from "react-inner-image-zoom";
import "react-inner-image-zoom/lib/InnerImageZoom/styles.css";
import FullScreenLoader from "../../components/Common/Loader";
import { useCount } from "../../Context/CountContext";
import { styleSearchDetail } from "../../api/jewelleryService";
import EnquiryModal from "../Enquiry/EnquiryModal";
import { insertEnquiry } from "../../api/enquiryService";
import { useFilters } from "../../Context/FilterContext";
import CommonPopUpModal from "../../components/Common/CommonPopUpModal";
import PriceValue from "../../components/Common/PriceValue";
import { Tooltip } from "reactstrap";
import CommonToastContainer from "../../components/Common/CommonToastContainer";
import VaultEmptyState from "./VaultEmptyState";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function VaultAccessDetail() {
    document.title = "Vault Access Detail";

    const { markProductInEnquiry,
        markProductInCart
    } = useFilters();
    const navigate = useNavigate();
    const { style_ID } = useParams();
    const { fetchCartCount, fetchEnquiryCount } = useCount();
    const [product, setProduct] = useState(null);
    const [materials, setMaterials] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [modalImageIndex, setModalImageIndex] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [collectionDetail, setCollectionDetail] = useState([]);
    const [addingToCart, setAddingToCart] = useState(false);
    const [isInCart, setisInCart] = useState([]);
    const [isInEnquiry, setisInEnquiry] = useState([]);
    const [isEnquiryOpen, setIsEnquiryOpen] = useState(false);
    const [EnquiryItems, setEnquiryItems] = useState([]);
    const [productItem, setProductItem] = useState(null);
    const [EnquiryRemark, setEnquiryRemark] = useState("");
    const [submittingEnquiry, setSubmittingEnquiry] = useState(false);
    const [commonModalTitle, setCommonModalTitle] = useState("");
    const [commonModalMessage, setCommonModalMessage] = useState("");
    const [commonModalPageType, setCommonModalPageType] = useState("");
    const [isCommonModalOpen, setIsCommonModalOpen] = useState(false);
    const [addingProductId, setAddingProductId] = useState(null);
    const [showLoader, setShowLoader] = useState(false);
    const [loadedImages, setLoadedImages] = useState({});
    const [tooltipOpen, setTooltipOpen] = useState({});
    const [toasts, setToasts] = useState([]);
    const [copied, setCopied] = useState(false);
    const isSkeletonLoading = !product;

    const showToast = (toastData) => {
        setToasts((prev) => [...prev, { id: Date.now(), ...toastData }]);
    };

    const removeToast = (id) => {
        setToasts((prev) => prev.filter((t) => t.id !== id));
    };
   
    const isInvalid = (val) =>
        val === null || val === undefined || val === "" || Number(val) === 0;

    const formatPcsCts = (pcs, wt) => {
        return isInvalid(pcs) || isInvalid(wt)
            ? "-"
            : `${pcs} Pcs / ${wt} Cts`;
    };

    const toggleTooltip = (id) => {
        setTooltipOpen(prev => ({ ...prev, [id]: !prev[id] }));
    };

    const openModal = (index) => {
        setModalImageIndex(index);
        setShowModal(true);
    };

    const closeModal = () => setShowModal(false);

    const nextImage = () => {
        setModalImageIndex((prev) =>
            prev === product.images.length - 1 ? 0 : prev + 1
        );
    };

    const prevImage = () => {
        setModalImageIndex((prev) =>
            prev === 0 ? product.images.length - 1 : prev - 1
        );
    };

    const showValue = (value) => {
        if (
            value === null ||
            value === undefined ||
            value === "" ||
            Number(value) === 0
        ) {
            return null;
        }
        return value;
    };
  
    const fetchProductDetailData = async () => {
        try {
            setLoading(true);
            setError(null);

            const payload = {
                Style_ID: style_ID,
                PageNo: "1",
                PageSize: "50",
            };

            const response = await styleSearchDetail(payload);
            const apiData = response?.data ?? response;

            const productItem = apiData?.ProductDetail?.[0];
            setProductItem(productItem);
            const materialDetail = apiData?.MaterialDetail ?? [];
            const CollectionDetail = apiData?.CollectionDetail ?? [];

            if (!productItem) {
                throw new Error("Product not found");
            }

            const mappedProduct = {
                Shortdescription: productItem.Shortdescription,
                Style_ID: productItem.Style_ID,
                Status: productItem.Status,
                StockType: productItem.StockType,
                MetalQuality: productItem.MetalQuality,
                MetalTone: productItem.MetalTone,
                ItemSize: productItem.ItemSize,
                StoneQuality: productItem.StoneQuality,
                JewelCode: productItem.JewelCode,
                StyleNo: productItem.StyleNo,
                Category: productItem.Category,
                HallmarkNo: productItem.HallmarkNo,
                CertificateNo: productItem.CertificateNo,
                GrossWt: productItem.GrossWt,
                TotalNetWt: productItem.TotalNetWt,
                DiaWt: productItem.DiaWt,
                DiaPcs: productItem.DiaPcs,
                CDiaWt: productItem.CDiaWt,
                CDiaPcs: productItem.CDiaPcs,
                NewArrivalStatus: productItem.NewArrivalStatus,
                PriceRemark: productItem.PriceRemark,
                LineAmount: productItem.LineAmount,
                LineDiscount: productItem.LineDiscount,
                images: [
                    productItem.Image1 || "/assets/images/noImage/no-image3.png",
                    productItem.Image2 || "/assets/images/noImage/no-image3.png",
                    productItem.Image3 || "/assets/images/noImage/no-image3.png",
                    productItem.Image4 || "/assets/images/noImage/no-image3.png",
                ].filter(Boolean),
            };

            const isTrue = (val) =>
                ["YES", "TRUE", "1", "Y"].includes(String(val ?? "").toUpperCase());

            const isInCart = isTrue(productItem.IS_AddedInCart);
            const isInEnquiry = isTrue(productItem.IS_AddedInEnquiry);

            setisInCart(isInCart);
            setisInEnquiry(isInEnquiry);


            const materialDetails = response?.MaterialDetail || [];
            const collectionDetail = response?.CollectionDetail || [];

            setCollectionDetail(collectionDetail);
            setProduct(mappedProduct);
            setMaterials(materialDetails);
            addToRecentViews(mappedProduct);
        } catch (err) {
            console.error("Product detail error:", err);
            showToast({
                title: "Error!",
                message: err.message || "Failed to load product details",
                type: "error",
            });
            setProduct(null);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (style_ID) fetchProductDetailData();
    }, [style_ID]);

    useEffect(() => {
        document.title = product
            ? `${product.Shortdescription} - Vault Access`
            : "Product Details";
    }, [product]);

    useEffect(() => {
        document.body.style.overflow = showModal ? "hidden" : "";
    }, [showModal]);

    const addToRecentViews = (product) => {
        let recent = JSON.parse(localStorage.getItem("recentViews")) || [];
        recent = recent.filter((p) => p.style_ID !== product.style_ID);
        recent.unshift(product);
        localStorage.setItem("recentViews", JSON.stringify(recent.slice(0, 8)));
    };
    if (!loading && (error || !product)) {
        return (
            <VaultEmptyState
                title="Product Detail Not Found"
                description="Product details are currently unavailable.
                             This information may be temporarily inaccessible.
                             Please check back after some time or explore other designs available in Vault Access."
                showButton={true}
            />
        );
    }

    const openEnquiryModal = (productItem) => {
        
        setEnquiryItems(prev => {
            const exists = prev.some(p => p.Style_ID === productItem.Style_ID);
            if (exists) return prev;

            return [
                ...prev,
                {
                    Style_ID: productItem.Style_ID,
                    StyleNo: productItem.StyleNo,
                    JewelCode: productItem.JewelCode,
                    Shortdescription: productItem.Shortdescription,
                    MetalQuality: productItem.MetalQuality,
                    MetalTone: productItem.MetalTone,
                    TotalNetWt: productItem.TotalNetWt,
                    Cart_ID: null,
                    Qunatity: 1
                }
            ];
        });
        setIsEnquiryOpen(true);
        
    };

    const resetEnquiryState = () => {
        setEnquiryItems([]);
        setEnquiryRemark("");
        setIsEnquiryOpen(false);
    };

    const removeEnquiryItem = (productId) => {
        setEnquiryItems(prev =>
            prev.filter(p => p.Style_ID !== productId)
        );
    };

    const submitEnquiry = async () => {
        if (!EnquiryItems.length) return;
        setSubmittingEnquiry(true);

        const payload = {
            Enquiry_ID: "0",
            EnquiryNo: "",
            Status: "PENDING",
            StatusComment: EnquiryRemark,
            StyleCount: String(EnquiryItems.length),
            Styles: EnquiryItems.map(x => ({
                Style_ID: x.Style_ID,
                StyleNo: x.StyleNo,
                JewelCode: x.JewelCode,
                Cart_ID: x.Cart_ID != null ? String(x.Cart_ID) : ""
            }))
        };

        try {
            const res = await insertEnquiry(payload);
            console.log("response: ", res)
            if (res?.Message?.[0]?.ReturnCode !== "1") {
                console.error("Error inserting enquiry:", res?.ZMESSAGE);
                setCommonModalTitle("Error");
                setCommonModalMessage(res?.Message?.[0]?.ReturnMessage || "Failed to create enquiry");
                setCommonModalPageType("error");
                setIsCommonModalOpen(true);
                return;
            }
            console.log("Rsponse,", res)
            const messageObj = res?.EnquiryData?.[0];
            const rawMsg = messageObj?.ReturnMessage || "";
            const normalizedMsg = rawMsg.replace(/\s+/g, " ").trim();
            const enquiryNoMatch = normalizedMsg.match(/Enquiry\s*No\s*=\s*([A-Z0-9/]+)/i);
            const enquiryNo = enquiryNoMatch ? enquiryNoMatch[1] : "Enquiry Created";      
            const cleanMessage = normalizedMsg
                .replace(/^\(\d+\)\s*/g, "")
                .replace(/\(Enquiry\s*No\s*=.*?\)/i, "")
                .trim();
            const styleIds = EnquiryItems.map(x => x.Style_ID);
            markProductInEnquiry(styleIds);
            setIsEnquiryOpen(false);
            fetchEnquiryCount();
            setCommonModalTitle(enquiryNo);
            setCommonModalMessage(cleanMessage);
            setCommonModalPageType("enquiry");
            setIsCommonModalOpen(true);
            setisInEnquiry("YES");
        } catch (err) {
            console.error("Exception inserting enquiry:", error);
            const ERRORMessage = err?.response?.data?.Message?.[0]?.ReturnMessage || err?.message || "Something went wrong";
            setCommonModalTitle("Error");
            setCommonModalMessage(ERRORMessage);
            setCommonModalPageType("error");
            setIsCommonModalOpen(true);
        } finally {
            setSubmittingEnquiry(false);
        }
    };

    const copyEnquiryNo = () => {
        if (!isValidEnquiryNo(commonModalTitle)) return;

        navigator.clipboard.writeText(commonModalTitle).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 1500);
        });
    };

    const isValidEnquiryNo = (val) => {
        if (!val) return false;
        return /^[A-Z]{1,5}\/\d{1,4}\/\d{1,4}$/i.test(val);
    };

    const handleAddToCart = async (product) => {
        setShowLoader(true);
        setAddingProductId(product.Style_ID);
        try {
            const payload = {
                Style_ID: product.Style_ID,
                JewelCode: product.JewelCode,
                StyleNo: product.StyleNo,
                Quantity: "1",
            };
            const res = await AddToCart(payload);
            const messageObj = res?.ZMESSAGE?.[0];
            if (messageObj?.RETURNCODE === "1") {
                showToast({
                    title: "Success!",
                    message: messageObj?.RETURNMESSAGE,
                    type: "success",
                });
                markProductInCart(product.Style_ID);
                fetchCartCount();            
                setisInCart("Yes")
            } else {
                showToast({
                    title: "Error!",
                    message: messageObj?.RETURNMESSAGE || "Failed to add product",
                    type: "error",
                });
            }
        } catch (error) {
            console.error(error);
            showToast({
                title: "Error!",
                message: "Something went wrong",
                type: "error",
            });
        } finally {
            setShowLoader(false);
            setAddingProductId(null);           
        }
    };

    const handleImageLoad = (index) => {
        setLoadedImages(prev => ({ ...prev, [index]: true }));
    };

    const handleImageError = (e, index) => {
        e.currentTarget.src = "/assets/images/vaultaccess/no-image3.png";
        setLoadedImages(prev => ({ ...prev, [index]: true }));
    };

    return (
        <>
            {addingToCart && <FullScreenLoader />}
            <section className="Vault-access-detail">
                <div className="container-fluid">
                    {isSkeletonLoading ? (
                        <div className="row g-4 align-items-start">
                            <div className="col-lg-8 col-md-12">
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <div className="image-box w-100 position-relative"> </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="image-box w-100 position-relative"> </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="image-box w-100 position-relative"> </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="image-box w-100 position-relative"> </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-12">
                                <div className="Product-Detail-section">
                                    <div className="product-heading">
                                        <h3 className="fw-bold mb-3 d-flex align-items-center gap-2">
                                            <span className="text-primary fw-bold">
                                                <Skeleton width={450} height={20} />
                                            </span>
                                            <Skeleton width={50} height={20} />
                                            <Skeleton width={50} height={20} />
                                        </h3>
                                        <div className="d-flex align-items-baseline">
                                            <h5 className="fw-bold me-1">Product Code: </h5>
                                            <Skeleton width={140} height={20} />
                                        </div>
                                        <Skeleton width={140} height={20} />
                                    </div>
                                    <div className="Details-section row">
                                        <div className="product-details">
                                            <h4 className="text-primary fw-bold mt-2"> Product Details: </h4>
                                            <p><b>Gold Purity:</b>{" "} <Skeleton width={140} height={20} /></p>
                                            <p><b>Gold Weight:</b> <Skeleton width={140} height={20} /></p>
                                            <p><b>Dimension:</b> <Skeleton width={140} height={20} /></p>
                                        </div>
                                        <div className="diamond-details mt-2">
                                            <h4 className="text-primary fw-bold"> Diamond Details: </h4>
                                            <p className="fw-bold"> Diamond Weight: <span className="fw-normal"><Skeleton width={140} height={20} /></span> </p>
                                            <p className="fw-bold"> Color Diamond: <span className="fw-normal"><Skeleton width={140} height={20} /></span> </p>
                                            <p className="fw-bold"> Gross Weight: <span className="fw-normal"><Skeleton width={140} height={20} /></span> </p>
                                            <p><b>Hallmark No:</b> <Skeleton width={140} height={20} /></p>
                                            <p><b>Certificate No:</b> <Skeleton width={140} height={20} /></p>
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex text-center mt-3">
                                    <span className="d-flex">
                                        <div className="enquiryBtn me-3">
                                            <Skeleton width={140} height={35} />
                                        </div>
                                        <div className="cartBtn">
                                            <Skeleton width={140} height={35} />
                                        </div>
                                    </span>
                                </div>
                                <div className="py-3 bg-white shadow-sm rounded category-sidebar col-12">
                                    <h4 className="text-primary fw-bold">Collection Details</h4>
                                    <ul className="list-unstyled mb-0 blog-list">
                                        {Array.from({ length: 4 }).map((_, i) => (
                                            <li className="mb-2" key={i}>
                                                <p className="small collection-item mb-0">
                                                    <i className="bx bx-wifi-0 fs-3"></i>
                                                    <span>
                                                        <Skeleton width={100} height={20} />
                                                    </span>
                                                </p>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="row g-4 align-items-start">
                            <div className="col-lg-8 col-md-12">
                                <div className="row g-3">
                                    {product.images.map((img, index) => (
                                        <div className="col-md-6" key={index}>
                                            <div className="" key={index}>
                                                <div className="image-box w-100 position-relative">
                                                    {!loadedImages[index] && (
                                                        <div className="skeleton-wrapper-vaultdetail">
                                                            <div className="skeleton-image-vaultdetail" />
                                                        </div>
                                                    )}
                                                    {index === 0 && (
                                                        <button className="back-btn" onClick={() => window.history.back()} aria-label="Go back">
                                                            <i className="fas fa-arrow-left"></i>
                                                        </button>
                                                    )}
                                                    <img
                                                        src={product.images[index]}
                                                        alt={`Product ${index + 1}`}
                                                        loading="lazy"
                                                        className="image-thumb img-fluid"
                                                        style={{
                                                            opacity: loadedImages[index] ? 1 : 0,
                                                            transition: "opacity 0.3s ease",
                                                        }}
                                                        onLoad={() => handleImageLoad(index)}
                                                        onError={(e) => handleImageError(e, index)}
                                                    />
                                                    <button className="zoom-btn" onClick={(e) => { e.stopPropagation(); openModal(index); }}>
                                                        <i className="fas fa-search-plus"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-12">
                                <div className="Product-Detail-section">
                                    <div className="product-heading">
                                        <h3 className="fw-bold mb-3 d-flex align-items-center gap-2">
                                            <span className="text-primary fw-bold">
                                                {product.Shortdescription || "Product Detail"}
                                            </span>
                                            {Number(product.Status) !== 0 && (
                                                <span className="badge badge-status badge-detail">
                                                    {String(product.Status).toUpperCase()}                                                
                                                </span>
                                            )}

                                            {Number(product.NewArrivalStatus) !== 0 && (
                                                <span className="badge badge-new-arrival">
                                                    {String(product.NewArrivalStatus).toUpperCase()}
                                                </span>
                                            )}
                                        </h3>
                                        <div className="d-flex align-items-baseline">
                                            <h5 className="fw-bold me-1">Product Code: </h5>
                                            <span>{showValue(product.StyleNo)} /  {showValue(product.JewelCode)}</span>
                                        </div>
                                        <PriceValue
                                            lineAmount={product.LineAmount}
                                            lineDiscount={product.LineDiscount}
                                            priceRemark={product.PriceRemark}
                                        />
                                    </div>
                                    <div className="Details-section row">                                   
                                        <div className="product-details">
                                            <h4 className="text-primary fw-bold mt-2"> Product Details: </h4>
                                            <p><b>Gold Purity:</b>{" "}{showValue(product.MetalQuality)} / {showValue(product.MetalTone)}</p>
                                            <p><b>Gold Weight:</b> {showValue(product.TotalNetWt)}</p>
                                            <p><b>Dimension:</b> {showValue(product.ItemSize)}</p>
                                        </div>
                                        <div className="diamond-details mt-2">
                                            <h4 className="text-primary fw-bold"> Diamond Details: </h4>
                                            <p className="fw-bold"> Diamond Weight: <span className="fw-normal"> {" "}{formatPcsCts(product.DiaPcs, product.DiaWt)} </span> </p>
                                            <p className="fw-bold"> Color Diamond: <span className="fw-normal"> {" "}{formatPcsCts(product.CDiaPcs, product.CDiaWt)} </span> </p>
                                            <p className="fw-bold"> Gross Weight: <span className="fw-normal"> {" "}{isInvalid(product.GrossWt) ? "-" : product.GrossWt} </span> </p>
                                            <p><b>Hallmark No:</b>{showValue(product.HallmarkNo) || "-"}</p>
                                            <p><b>Certificate No:</b> {showValue(product.CertificateNo) || "-"}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex text-center mt-3">
                                    <span
                                        id={`detail-enquiry-btn-${product.Style_ID}`}
                                        className="me-3 d-inline-block"
                                        style={{ cursor: isInEnquiry ? "not-allowed" : "pointer" }}
                                    >
                                        <button
                                            type="button"
                                            className={`btn-animate-enquiry fs-6 ${isInEnquiry ? "btn-outline-enquiry disabled-btn" : "" }`}
                                            disabled={isInEnquiry}
                                            onClick={() => openEnquiryModal(productItem)}
                                        >
                                            {isInEnquiry ? "IN ENQUIRY" : "ENQUIRE NOW"}
                                        </button>
                                    </span>

                                    {isInEnquiry && (
                                        <Tooltip
                                            fade={false}
                                            placement="top"
                                            isOpen={!!tooltipOpen[`detail-enquiry-btn-${product.Style_ID}`]}
                                            target={`detail-enquiry-btn-${product.Style_ID}`}
                                            toggle={() =>
                                                toggleTooltip(`detail-enquiry-btn-${product.Style_ID}`)
                                            }
                                        >
                                            This product is already added to enquiry
                                        </Tooltip>
                                    )}

                                    <span
                                        id={`detail-cart-btn-${product.Style_ID}`}
                                        className="d-inline-block"
                                        style={{ cursor: isInCart || isInEnquiry ? "not-allowed" : "pointer" }}
                                    >
                                        <button
                                            type="button"
                                            className={`btn-animate-addtocart fs-6 ${isInCart
                                                    ? "btn-outline-cart disabled-btn"
                                                    : isInEnquiry
                                                        ? "disabled-btn"
                                                        : ""
                                                }`}
                                            disabled={isInCart || isInEnquiry || addingToCart}
                                            onClick={() => handleAddToCart(productItem)}
                                        >
                                            {isInCart ? "IN CART" : "ADD TO CART"}
                                        </button>
                                    </span>

                                    {(isInCart || isInEnquiry) && (
                                        <Tooltip
                                            fade={false}
                                            placement="top"
                                            isOpen={!!tooltipOpen[`detail-cart-btn-${product.Style_ID}`]}
                                            target={`detail-cart-btn-${product.Style_ID}`}
                                            toggle={() =>
                                                toggleTooltip(`detail-cart-btn-${product.Style_ID}`)
                                            }
                                        >
                                            {isInCart
                                                ? "This product is already in your cart"
                                                : "Products in enquiry can’t be added to cart"}
                                        </Tooltip>
                                    )}
                                </div>
                                <div className="py-3 bg-white shadow-sm rounded category-sidebar col-12">
                                    <h4 className="text-primary fw-bold">Collection Details</h4>
                                    <ul className="list-unstyled mb-0 blog-list">
                                        {collectionDetail.map((collection, i) => (
                                            <li className="mb-2" key={i}>
                                                <p className={`small collection-item mb-0 ${collection.ISBaseCollection ? "fw-bold text-primary base-collection" : "" }`}>
                                                    <i className="bx bx-wifi-0 fs-3"></i>
                                                    <span>{collection.Collection}</span>
                                                    {collection.ISBaseCollection && (
                                                        <span className="base-collection-hover"> Base Collection </span>
                                                    )}
                                                </p>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                   )}
                    {showModal && (
                        <div className="fullscreen-modal" onClick={closeModal}>
                            <button className="modal-close-btn" onClick={closeModal} aria-label="Close">
                                <i className="fa fa-times"></i>
                            </button>
                            <div className="modal-image-wrapper" onClick={(e) => e.stopPropagation()}>
                                <InnerImageZoom
                                    src={product.images[modalImageIndex]}
                                    zoomSrc={product.images[modalImageIndex]}
                                    zoomType="click"
                                    moveType="drag"
                                    zoomScale={2}
                                    hasSpacer={false}
                                />
                            </div>
                            <div className="modal-pagination" onClick={(e) => e.stopPropagation()}>
                                <button onClick={prevImage}>
                                    ‹
                                </button>

                                <span> {modalImageIndex + 1} / {product.images.length} </span>

                                <button onClick={nextImage}>
                                    ›
                                </button>
                            </div>
                        </div>
                    )}
                    {/*<SimilarProductsSlider*/}
                    {/*    currentProductId={style_ID}*/}
                    {/*    category={product.category}*/}
                    {/*/>*/}
                    {/*<RecentViewedSlider />*/}
                </div>
            </section>

            <EnquiryModal
                isOpen={isEnquiryOpen}
                toggle={resetEnquiryState}
                items={EnquiryItems}
                remark={EnquiryRemark}
                setRemark={setEnquiryRemark}
                onRemoveItem={removeEnquiryItem}
                onSubmit={submitEnquiry}
                submitting={submittingEnquiry}
                title="Product Enquiry"
            />
            <CommonPopUpModal
                isOpen={isCommonModalOpen}
                onClose={() => setIsCommonModalOpen(false)}
                message={commonModalMessage}
                pageType={commonModalPageType}
                title={
                    commonModalPageType === "enquiry" ? (
                        <>
                            <div className="popup-subtitle">
                                Thanks for reaching out to us.
                            </div>

                            <div className="popup-enquiry-label">
                                Your Enquiry No is
                            </div>

                            <div
                                className={`popup-enquiry-no ${isValidEnquiryNo(commonModalTitle) ? "copyable" : ""
                                    }`}
                                onClick={copyEnquiryNo}
                                title={
                                    isValidEnquiryNo(commonModalTitle)
                                        ? "Click to copy"
                                        : ""
                                }
                            >
                                <span>{commonModalTitle}</span>

                                {isValidEnquiryNo(commonModalTitle) && (
                                    <span className={`copy-wrapper ${copied ? "copied" : ""}`}>
                                        <i className="bx bx-copy copy-icon" />
                                        {copied && (
                                            <span className="copied-tooltip">
                                                Copied!
                                            </span>
                                        )}
                                    </span>
                                )}
                            </div>
                        </>
                    ) : (
                        commonModalTitle
                    )
                }
            />
            <CommonToastContainer toasts={toasts} removeToast={removeToast} />
        </>
    );
}
